"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var minimal_1 = require("@sentry/minimal");
var misc_1 = require("@sentry/utils/misc");
var logger_1 = require("../logger");
/** Deduplication filter */
var Dedupe = /** @class */function () {
  function Dedupe() {
    /**
     * @inheritDoc
     */
    this.name = 'Dedupe';
  }
  /**
   * @inheritDoc
   */
  Dedupe.prototype.install = function () {
    var _this = this;
    minimal_1.configureScope(function (scope) {
      scope.addEventProcessor(function (currentEvent) {
        return __awaiter(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            // Juuust in case something goes wrong
            try {
              if (this.shouldDropEvent(currentEvent, this.previousEvent)) {
                return [2 /*return*/, null];
              }
            } catch (_oO) {
              return [2 /*return*/, this.previousEvent = currentEvent];
            }
            return [2 /*return*/, this.previousEvent = currentEvent];
          });
        });
      });
    });
  };
  /** JSDoc */
  Dedupe.prototype.shouldDropEvent = function (currentEvent, previousEvent) {
    if (!previousEvent) {
      return false;
    }
    if (this.isSameMessageEvent(currentEvent, previousEvent)) {
      logger_1.logger.warn("Event dropped due to being a duplicate of previous event (same message).\nEvent: " + misc_1.getEventDescription(currentEvent));
      return true;
    }
    if (this.isSameExceptionEvent(currentEvent, previousEvent)) {
      logger_1.logger.warn("Event dropped due to being a duplicate of previous event (same exception).\nEvent: " + misc_1.getEventDescription(currentEvent));
      return true;
    }
    return false;
  };
  /** JSDoc */
  Dedupe.prototype.isSameMessageEvent = function (currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If no event has a message, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
      return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) {
      return false;
    }
    if (currentMessage !== previousMessage) {
      return false;
    }
    if (!this.isSameFingerprint(currentEvent, previousEvent)) {
      return false;
    }
    if (!this.isSameStacktrace(currentEvent, previousEvent)) {
      return false;
    }
    return true;
  };
  /** JSDoc */
  Dedupe.prototype.getFramesFromEvent = function (event) {
    var exception = event.exception;
    if (exception) {
      try {
        // @ts-ignore
        return exception.values[0].stacktrace.frames;
      } catch (_oO) {
        return undefined;
      }
    } else if (event.stacktrace) {
      return event.stacktrace.frames;
    } else {
      return undefined;
    }
  };
  /** JSDoc */
  Dedupe.prototype.isSameStacktrace = function (currentEvent, previousEvent) {
    var currentFrames = this.getFramesFromEvent(currentEvent);
    var previousFrames = this.getFramesFromEvent(previousEvent);
    // If no event has a fingerprint, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
      return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) {
      return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
      return false;
    }
    // Otherwise, compare the two
    for (var i = 0; i < previousFrames.length; i++) {
      var frameA = previousFrames[i];
      var frameB = currentFrames[i];
      if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) {
        return false;
      }
    }
    return true;
  };
  /** JSDoc */
  Dedupe.prototype.getExceptionFromEvent = function (event) {
    return event.exception && event.exception.values && event.exception.values[0];
  };
  /** JSDoc */
  Dedupe.prototype.isSameExceptionEvent = function (currentEvent, previousEvent) {
    var previousException = this.getExceptionFromEvent(previousEvent);
    var currentException = this.getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
      return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
      return false;
    }
    if (!this.isSameFingerprint(currentEvent, previousEvent)) {
      return false;
    }
    if (!this.isSameStacktrace(currentEvent, previousEvent)) {
      return false;
    }
    return true;
  };
  /** JSDoc */
  Dedupe.prototype.isSameFingerprint = function (currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If no event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
      return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) {
      return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
      return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
      return false;
    }
  };
  return Dedupe;
}();
exports.Dedupe = Dedupe;